export default __webpack_public_path__ + "static/media/Foot_left.b6ced133.svg";